@if (connectionForms().length > 0) {
  <mat-card>
    <mat-card-header class="full-width-header">
      <mat-card-title>
        <div class="title-row">
          @if (triggerFeatureFlagEnabled()) {
            <span>{{ 'AI_ASSISTANT.SETTINGS.TRIGGERS.TITLE' | translate }}</span>
          } @else {
            <span>{{ 'AI_ASSISTANT.SETTINGS.CHANNELS.TITLE' | translate }}</span>
          }
          @if (connectionForms().dirty) {
            <span class="unsaved-changes-text">
              {{ 'AI_ASSISTANT.SHARED.UNSAVED_CHANGES.TITLE' | translate }}
            </span>
          }
        </div>
      </mat-card-title>
      @if (triggerFeatureFlagEnabled()) {
        <mat-card-subtitle>{{ 'AI_ASSISTANT.SETTINGS.TRIGGERS.SUBTITLE' | translate }}</mat-card-subtitle>
      } @else {
        <mat-card-subtitle>{{ 'AI_ASSISTANT.SETTINGS.CHANNELS.SUBTITLE' | translate }}</mat-card-subtitle>
      }
    </mat-card-header>
    <mat-card-content>
      @for (connectionForm of displayedConnections(); track connectionForm) {
        <glxy-form-field bottomSpacing="none">
          <mat-checkbox [formControl]="connectionForm.controls.connected" class="connections-checkbox">
            <div class="checkbox-icon-and-label-wrapper">
              <img [src]="connectionForm.metadata.iconUrl" alt="avatar" class="connection-icon" />
              <div>
                <div>
                  <div>{{ connectionForm.metadata.name }}</div>
                  @if (connectionForm.metadata.hasOtherConnections) {
                    <div class="connection-notice">
                      @if (triggerFeatureFlagEnabled()) {
                        {{ 'AI_ASSISTANT.SETTINGS.TRIGGERS.EXISTING_TRIGGER' | translate }}
                      } @else {
                        {{ 'AI_ASSISTANT.SETTINGS.CHANNELS.EXISTING_CONNECTION' | translate }}
                      }

                      @if (connectionForm.controls.connected.value) {
                        <mat-icon
                          [glxyTooltip]="triggerFeatureFlagEnabled() ? 'AI_ASSISTANT.SETTINGS.TRIGGERS.EXISTING_TRIGGER_TOOLTIP' : 'AI_ASSISTANT.SETTINGS.CHANNELS.EXISTING_CONNECTION_TOOLTIP' | translate"
                          class="warning-icon"
                          >warning</mat-icon
                        >
                      }
                    </div>
                  }
                </div>
                @if (connectionForm.metadata.cta?.action?.showButton) {
                  <a
                    (click)="triggerAction(connectionForm.metadata); $event.preventDefault()"
                    class="connections-checkbox-settings-link"
                  >
                    @if (connectionForm.metadata.isDefault && !connectionForm.metadata.cta?.label) {
                      {{
                        triggerFeatureFlagEnabled() ? 'AI_ASSISTANT.SETTINGS.SETUP_TRIGGER' : 'AI_ASSISTANT.SETTINGS.SETUP_CONNECTIONS'
                          | translate: { connectionName: connectionForm.metadata.name }
                      }}
                    } @else {
                      {{ connectionForm.metadata.cta?.label || 'AI_ASSISTANT.SETTINGS.SETTINGS' | translate }}
                    }
                  </a>
                }
              </div>
            </div>
          </mat-checkbox>
        </glxy-form-field>
      }
      @if (shouldShowToggleButton()) {
        <p 
          class="toggle-connections-button"
          [class.toggle-connections-button-view-less-state]="showAllConnections()"
          (click)="toggleShowAllConnections()"
          [attr.aria-expanded]="showAllConnections()"
        >
          {{ toggleButtonText() | translate }}
        </p>
      }
    </mat-card-content>
    @if (showManageButton()) {
      <mat-card-footer class="card-footer">
        <a mat-stroked-button [routerLink]="manageChannelsRoute()">
          @if (triggerFeatureFlagEnabled()) {
            {{ 'AI_ASSISTANT.SETTINGS.MANAGE_TRIGGERS' | translate }}
          } @else {
            {{ 'AI_ASSISTANT.SETTINGS.MANAGE_CHANNELS' | translate }}
          }
        </a>  
      </mat-card-footer>
    }
  </mat-card>
}
